import { useEffect, useRef, useState } from "react";
import "../../styles/EduComponents/Passion.css";
import CallbackForm from "./CallbackForm";

import calander from "../../assets/Images/calander.webp";
import notification from "../../assets/Images/notification - Copy.webp";
import search from "../../assets/Images/search - Copy.webp";
import info from "../../assets/Images/info.webp";
import work from "../../assets/Images/work - Copy.webp";
import money from "../../assets/Images/money - Copy.webp";

const slidesData = [
  {
    title: "Awkward Payment Chasing",
    text: "Feeling uncomfortable reminding parents about overdue fees.",
    img: money,
  },
  {
    title: "Tedious Attendance Tracking",
    text: "Manually recording who's present, leading to errors and wasted time.",
    img: calander,
  },
  {
    title: "Constant Communication Overload",
    text: "Sending individual reminders and updates, draining your focus.",
    img: notification,
  },
  {
    title: "Lack of Curriculum Oversight",
    text: "Wondering if all instructors are consistently delivering your academy's quality.",
    img: search,
  },
  {
    title: "Time-Consuming Lesson Planning",
    text: "Struggling to recall past lessons and plan effectively for the next class.",
    img: info,
  },
  {
    title: "Frustrating Progress Reporting",
    text: "Spending hours creating reports that offer little real insight to parents.",
    img: work,
  },
];

const Passion = () => {
  const [showForm, setShowForm] = useState(false);
  const [current, setCurrent] = useState(0);
  const trackRef = useRef(null);
  const cardRef = useRef(null);
  const autoplayRef = useRef(null);
  const [offset, setOffset] = useState({
    slideOffset: 0,
    centerOffset: 0,
  });
  const isMobile = () => window.innerWidth <= 768;

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setCurrent(1);
    }
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    window.location.href = process.env.REACT_APP_TIDYCAL_URL;
  };

  const next = () => setCurrent((prev) => (prev + 1) % slidesData.length);

  const prev = () =>
    setCurrent((prev) => (prev === 0 ? slidesData.length - 1 : prev - 1));

  // ✅ calculate real card width dynamically
  useEffect(() => {
    const updateOffset = () => {
      if (!cardRef.current || !trackRef.current) return;

      const cardWidth = cardRef.current.offsetWidth;
      const gap = 40;
      const slideOffset = cardWidth + gap;

      let centerOffset = 0;

      // ✅ ONLY center on desktop
      if (!isMobile()) {
        const carouselWidth = trackRef.current.parentElement.offsetWidth;
        centerOffset = (carouselWidth - cardWidth) / 2;
      }

      setOffset({
        slideOffset,
        centerOffset,
      });
    };

    updateOffset();
    window.addEventListener("resize", updateOffset);
    return () => window.removeEventListener("resize", updateOffset);
  }, []);

  // autoplay
  // useEffect(() => {
  //   autoplayRef.current = setInterval(next, 6000);
  //   return () => clearInterval(autoplayRef.current);
  // }, []);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;

    if (diff > 50) next(); // swipe left → next
    if (diff < -50) prev(); // swipe right → prev
  };

  return (
    <section className="passion-container">
      <section className="passion-container1">
        <div className="left-text">
          <h1 className="lt1">
            Are you a passionate
            <span className="highlight">
              <br />
              instructor
            </span>{" "}
            ?
          </h1>
        </div>
        <div className="right-text">
          <p className="rtp">
            The daunting reality of administrative tasks can quickly overshadow
            the thrill of starting your academy. Do you struggle with admin
            tasks ?
          </p>
        </div>
      </section>

      <div className="carousel">
        <button className="carousel-nav prev" onClick={prev}>
          ‹
        </button>

        <div
          ref={trackRef}
          className="carousel-track"
          style={{
            transform: `translateX(${offset.centerOffset - current * offset.slideOffset}px)`,
          }}
        >
          {slidesData.map((slide, index) => (
            <article
              ref={index === 0 ? cardRef : null}
              key={index}
              className={`carousel-slide ${index === current ? "active" : ""}`}
              onClick={next}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <div className="passion-feature-inner">
                <h3 className="pt3">{slide.title}</h3>
                <p className="ptp">{slide.text}</p>
                <img src={slide.img} alt={slide.title} />
                <a
                  href="#"
                  className="pta"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowForm(true);
                  }}
                >
                  Request Callback
                </a>
              </div>
            </article>
          ))}
        </div>

        <button className="carousel-nav next" onClick={next}>
          ›
        </button>

        <div className="carousel-dots">
          {slidesData.map((_, i) => (
            <button
              key={i}
              className={`dot ${i === current ? "active" : ""}`}
              onClick={() => setCurrent(i)}
            />
          ))}
        </div>
      </div>
      <CallbackForm isOpen={showForm} onClose={() => setShowForm(false)} />
    </section>
  );
};

export default Passion;
